// src/layouts/AppLayout.jsx
import { useState } from 'react';
import { Box, CssBaseline } from '@mui/material';
import Sidebar from '../components/Sidebar';

const DRAWER_WIDTH = 240; // Sidebar 와 동일

export default function AppLayout({ children }) {
    const [openPC, setOpenPC] = useState(true);

    return (
        <Box
            sx={{
                display: 'flex',
                width: '100%',
                maxWidth: '100%',
                overflowX: 'hidden', // ✅ 최상위에서 페이지 가로삐짐 방지
            }}
        >
            <CssBaseline />

            {/* ───── Sidebar ───── */}
            <Sidebar showHamburger openExternal={openPC} setOpenExternal={setOpenPC} />

            {/* ───── Main content ───── */}
            <Box
                component="main"
                sx={(theme) => ({
                    flexGrow: 1,
                    minWidth: 0,            // ✅ flex 자식 overflow 방지 핵심
                    width: '100%',
                    maxWidth: '100%',
                    overflowX: 'hidden',    // ✅ 내부 테이블 등으로 페이지가 밀리지 않게

                    p: { xs: 1, sm: 3 },
                    bgcolor: '#f5f5f5',
                    minHeight: '100vh',

                    transition: theme.transitions.create(['margin'], {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.leavingScreen,
                    }),

                    // ✅ 모바일에서는 절대 marginLeft로 밀지 않음
                    marginLeft: { xs: 0, sm: openPC ? `${DRAWER_WIDTH}px` : 0 },
                })}
            >
                {children}
            </Box>
        </Box>
    );
}
